import { ParameterType } from '@/study-search/enums';
import { FilterDefinition } from '../definition';
import { FilterKey } from '@studyportals/search-filters/server-side';
import { ParsedFilter } from '../generalizations/ParsedFilter';

export abstract class Filter {
	public definition?: FilterDefinition = undefined;

	protected constructor(
		public readonly key: FilterKey,
		public readonly type: ParameterType,
		public values: string[],
		public collapsed = true,
		public readonly structured = true,
	) {
		this.type = type;
		this.values = values;
	}

	public canNotBeIndexed(): boolean {
		return !this.canBeIndexed();
	}

	public canBeIndexed(): boolean {
		return false;
	}

	public processValue(value: string): void {
		if (this.values.some((_) => _ === value)) {
			this.values.splice(this.values.indexOf(value), 1);

			return;
		}

		this.values.push(value);
	}

	public clearValue(value: string): void {
		if (this.values.some((_) => _ === value)) {
			this.values.splice(this.values.indexOf(value), 1);
		}
	}

	public emptyFilter(): void {
		this.values.splice(0, this.values.length);
	}

	public toggleFilter(): void {
		this.collapsed = !this.collapsed;
	}

	public toParsedFilter(): ParsedFilter {
		return new ParsedFilter(this.type, this.values);
	}
}
